/**
 * Pre-Firebase Console Patch
 * Runs at the absolute earliest moment to patch console
 * before Firebase SDK even loads
 */

// Immediately patch console on module import
const patchConsole = () => {
  if (typeof window === 'undefined') return;

  const originalLog = console.log;
  const originalWarn = console.warn;
  const originalError = console.error;

  // Aggressive suppression - match on ANY Firebase connection error patterns
  const shouldSuppress = (str: string): boolean => {
    if (!str) return false;
    const lower = String(str).toLowerCase();
    
    // Suppress entire Firebase connection/offline mode messages
    return (
      lower.includes('could not reach') ||
      lower.includes('connection failed') ||
      lower.includes('this typically indicates') ||
      lower.includes('transport errored') ||
      lower.includes('webchannel') ||
      lower.includes('code=unavailable') ||
      lower.includes('offline mode') ||
      lower.includes('healthy internet') ||
      lower.includes('@firebase/firestore') ||
      lower.includes('firestore (12.4.0)') ||
      (lower.includes('firestore') && lower.includes('error')) ||
      (lower.includes('connection') && lower.includes('firebase')) ||
      (lower.includes('backend') && lower.includes('firestore'))
    );
  };

  // Override all three methods
  console.log = function(...args: any[]) {
    const msg = String(args[0] || '');
    if (!shouldSuppress(msg)) {
      originalLog.apply(console, args);
    }
  };

  console.warn = function(...args: any[]) {
    const msg = String(args[0] || '');
    if (!shouldSuppress(msg)) {
      originalWarn.apply(console, args);
    }
  };

  console.error = function(...args: any[]) {
    const msg = String(args[0] || '');
    if (!shouldSuppress(msg)) {
      originalError.apply(console, args);
    }
  };
};

// Execute immediately when this module is imported
patchConsole();

// Log that suppression is active (to verify it's working)
if (typeof window !== 'undefined' && typeof console !== 'undefined') {
  try {
    // Use original console to verify suppression is active
    Object.getPrototypeOf(Object.getPrototypeOf(console.log)).call(
      console,
      '🔇 [FIREBASE-PREPATCH] Error suppression initialized'
    );
  } catch (e) {
    // Silently fail if prototype logging doesn't work
  }
}

export {};
